import React from "react";
import numeral from "numeral";
import { format, parseISO } from "date-fns";

class FlexibleDatePickerTable extends React.Component {
  constructor(props) {
    super(props);
  }
  

  render() {
    if (this.props.data && this.props.data.length > 0) {
      var headerColumns = this.props.data.map((d) => {
        return (
          <th key={d["date"]}>
            {format(parseISO(d["date"]), "eee")}
            <br />
            {format(parseISO(d["date"]), "M/d")}
          </th>
        );
      });

      headerColumns.unshift(<th key="room_name"></th>);

      var room_types = this.props.data[0]["room_types"];
      var bodyRows = room_types.map((room_type) => {
        var dateColumns = this.props.data.map((d) => {
          var rt = d["room_types"].filter((r) => {
            return r["id"] === room_type["id"];
          })[0];
          return <td key={d["date"]}>{this.renderRoomTypeDate(rt, d)}</td>;
        });
        return (
          <tr key={room_type["id"]}>
            <td className="room-type-name">
              <label>{room_type["name"]}</label>
            </td>
            {dateColumns}
          </tr>
        );
      });

      return (
        <div className="FlexibleDatePickerTableWrapper">
          <div className="FlexibleDatePickerTable">
            <table className="table">
              <thead>
                <tr>{headerColumns}</tr>
              </thead>
              <tbody>{bodyRows}</tbody>
            </table>
          </div>
        </div>
      );
    } else {
      return null;
    }
  }

  renderRoomTypeDate(room_type, date) {
    const dateStr = format(this.parseDate(date.date), "u-MM-dd");
    if (
      this.props.selectedDates[room_type.id + dateStr]
      //|| this.isPartOfReservationSegment(room_type, dateStr)
      //&& !this.props.deselectedDates[room_type.id + dateStr]
    ) {
      return (
        <div className="is-available date-selected">
          {/* <strong style={{ fontSize: "17px", lineHeight: "17px" }}>
            {this.renderAmount(room_type.amount)}
          </strong> */}
          <a
            href="#"
            // onClick={(e) => {
            //   e.preventDefault();
            //   e.stopPropagation();
            //   this.props.onRemoveRoomTypeDate(room_type, date);
            // }}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              this.props.onAddDatesToAccommodations(e);
            }}
            style={{ fontSize: "11px" }}
          >
            {/* {I18n.t("remove")} */}
            {I18n.t("next")}
          </a>
        </div>
      );
    } else if (room_type["available"]) {
      return (
        <div className="is-available">
          {/* <button
            type="button"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              this.props.onSelectRoomTypeDate(room_type, date);
            }}
            className="btn btn-sm btn-default"
          >
            {this.renderAmount(room_type.amount)}
          </button> */}
          <i className="fa fa-check" title={I18n.t('available')}style={{color: "#28a745",  fontSize: "18px"}}></i>
        </div>
      );
    } else {
      return (
        <div
          className="is-not-available"
          // style={{ color: "#777", fontSize: "12px" }}
          style={{ color: "#777", fontSize: "18px"}}
        >
          {/* {I18n.t("not_available")} */}
          <span className="ss-ban" title={I18n.t('not_available')}></span>
        </div>
      );
    }
  }

  renderAmount(amount) {
    return (
      <span>
        {this.props.currency.symbol}
        {numeral((amount * this.props.currency.exchange_rate) / 100).format(
          this.props.number_format
        )}
      </span>
    );
  }

  /**
   * Helper functions
   */
  parseDate(dateStr) {
    if (dateStr instanceof Date) {
      return dateStr;
    } else {
      return parseISO(dateStr);
    }
  }

  isPartOfReservationSegment(room_type, date) {
    date = this.parseDate(date);
    for (
      var i = 0, ilen = this.props.reservationSegments.length;
      i < ilen;
      i++
    ) {
      const seg = this.props.reservationSegments[i];
      if (seg && seg.room_type.id === room_type.id) {
        var start_date = this.parseDate(seg.start_date || seg.check_in_date);
        var end_date = this.parseDate(seg.end_date || seg.check_out_date);
        //console.log("room match!", seg, date, start_date, end_date);
        if (date >= start_date && date < end_date) {
          //console.log("dates within range!");
          return true;
        }
      }
    }
    return false;
  }
}

export default FlexibleDatePickerTable;
